import { useTranslation } from 'react-i18next';

import { AdProductsReviewSummaryVisibility } from '@features/campaigns/shared/containers/Review/AdProducts/getAdProductsReviewVisibility.ts';
import { AdProductsData } from '@features/campaigns/shared/containers/Review/Review.dto';
import { Item } from '@shared/components/Review/Item/Item';
import { VideoStatus } from '@shared/components/Review/VideoStatus/VideoStatus.tsx';
import { i18nNameSpace } from '@shared/consts/i18n.ts';

interface AdProductsSummaryProps {
  data: AdProductsData;
  visibility: AdProductsReviewSummaryVisibility;
}

export function AdProductsSummary({ data, visibility }: AdProductsSummaryProps) {
  const { t } = useTranslation(i18nNameSpace.CAMPAIGNS);

  return (
    <>
      <div className='row'>
        <div className='col-6'>
          <Item label={t('builder.formFields.formatType.label')} value={data.formatType} />
        </div>

        {visibility.shouldShowVideoStatus && (
          <div className='col-6'>
            <VideoStatus status={data.videoSpotStatus} />
          </div>
        )}

        {visibility.shouldShowInternalCreativeFields && (
          <>
            <div className='col-6 v-padding'>
              <Item label={t('builder.formFields.creativeServices.label')} value={data.creativeServices} />
            </div>

            <div className='col-6 v-padding'>
              <Item label={t('builder.formFields.numberOfCreatives.label')} value={String(data.numberOfCreatives)} />
            </div>
          </>
        )}

        {visibility.shouldShowVideoProductsIncluded && (
          <div className='col-6 v-padding'>
            <Item label={t('builder.formFields.videoProductsIncluded.label')} value={data.videoProductsIncluded} />
          </div>
        )}
      </div>

      {visibility.shouldShowTrackingUrl && (
        <div className='row'>
          <div className='col-12'>
            <Item label={t('builder.formFields.trackingUrl.label')} value={data.trackingUrl} />
          </div>
        </div>
      )}
    </>
  );
}
